import React, { Component } from 'react'
import IntroSection from '../containers/IntroSection'
import TimelineSection from '../containers/TimelineSection'
import ArticleListSection from '../containers/ArticleListSection'
import ArticleSection from '../containers/ArticleSection'
import CarouselSection from '../containers/CarouselSection'
import Header from '../components/Header'
import { virtualPush } from '../analytics'
import { interstitial } from '../ads'
import { scroller } from 'react-scroll'

class Index extends Component {
    componentDidMount() {
        virtualPush('', '70 שנה על הכביש');
        interstitial();
        const initialSection = this.props.match.params.section;
        if (initialSection) {
            setTimeout(() => {
                scroller.scrollTo(initialSection, {
                    duration: 1000,
                    smooth: true,
                    offset: -100
                });
            }, 800)
        }
    }
    render() {
        return (
            <div>
                <Header />
                <IntroSection />
                <TimelineSection />
                <ArticleListSection />
                <CarouselSection />
                <ArticleSection />
            </div>
        )
    }
}

export default Index;


// WEBPACK FOOTER //
// ./src/pages/Index.jsx